// extracted by mini-css-extract-plugin
module.exports = {"container":"_2LK5z748CZnVOwcPIORTUj","deleteIcon":"_2FNRsWLjZ7YotMDSXBDEwk"};